import { SelectOptionType } from '@octano/global-ui';

export const sexCIOptions: SelectOptionType[] = [
  { value: 1, label: 'Femenino' },
  { value: 2, label: 'Masculino' },
  { value: 3, label: 'No Binario' },
];

export const maritalStatusOptions: SelectOptionType[] = [
  { value: 1, label: 'Soltero/a' },
  { value: 2, label: 'Casado/a' },
  { value: 3, label: 'Viudo/a' },
  { value: 4, label: 'Divorciado/a' },
  { value: 5, label: 'Conviviente civil' },
];

export const educationalLevelOptions = [
  { value: 11, label: 'Básica Incompleta' },
  { value: 1, label: 'Básica Completa' },
  { value: 2, label: 'Media Incompleta' },
  { value: 3, label: 'Media Completa' },
  { value: 4, label: 'Superior Técnica' },
  { value: 5, label: 'Superior Profesional' },
  { value: 6, label: 'Licenciatura' },
  { value: 7, label: 'Profesional Universitaria' },
  { value: 8, label: 'Magister' },
  { value: 9, label: 'Doctorado' },
  { value: 10, label: 'No tengo información' },
];

export const familyGroupOptions = [
  { value: 1, label: 'Padres (uno o ambos)' },
  { value: 2, label: 'Padres (uno o ambos) y Hermanos' },
  { value: 3, label: 'Padres y abuelos (uno o más)' },
  { value: 4, label: 'Padres, abuelos y hermanos' },
  { value: 5, label: 'Conyuge (pareja)' },
  { value: 6, label: 'Conyuge (pareja) e hijos' },
  { value: 9, label: 'Sólo hijos' },
  { value: 7, label: 'Vivo solo' },
  { value: 8, label: 'Otros' },
];

export const parentalSurvivalOptions = [
  { value: 1, label: 'Padre y madre' },
  { value: 2, label: 'Solo Padre' },
  { value: 3, label: 'Solo Madre' },
  { value: 4, label: 'No tengo certeza' },
  { value: 5, label: 'Ninguno de los dos' },
];

export const ISAPRE = 1;
export const HAS_INSURANCE = 1;
export const HEALTH_CARE_OTHER = 3;

export const healthCareSystemOptions = [
  { value: 1, label: 'Isapre' },
  { value: 2, label: 'Fonasa' },
  { value: 3, label: 'Otro' },
];

export const healthCareProviderOptions = [
  { value: 1, label: 'Isapre Banmédica' },
  { value: 2, label: 'Isapre Consalud' },
  { value: 3, label: 'Isapre Colmena' },
  { value: 4, label: 'Isapre CruzBlanca' },
  { value: 5, label: 'Isapre Nueva Masvida' },
  { value: 6, label: 'Isapre Vida Tres' },
];

export const healthInsuranceOptions = [
  { value: 1, label: 'Si' },
  { value: 0, label: 'No' },
];

export const relationshipOptions = [
  { value: 1, label: 'Padre' },
  { value: 2, label: 'Madre' },
  { value: 3, label: 'Abuelo(a)' },
  { value: 4, label: 'Cónyuge' },
  { value: 5, label: 'Otro familiar' },
  { value: 6, label: 'Sin relación familiar' },
  { value: 7, label: 'Misma persona' },
];
export const RELATIONSHIP_NO_FAMILY = 6;
export const RELATIONSHIP_OWN_SUSTAINER = 7;

export const sustainerTypeOptions = [
  { value: 'OS', label: 'Soy mi propio sustentador' },
  { value: 'NP', label: 'Persona natural' },
  { value: 'LP', label: 'Persona jurídica' },
];

export const sustainerTypeWithPassportOptions = [
  { value: 'OS', label: 'Soy mi propio sustentador' },
  { value: 'NP', label: 'Persona natural' },
  { value: 'NPWP', label: 'Persona natural con pasaporte' },
  { value: 'LP', label: 'Persona jurídica' },
];

export enum SustainerType {
  OwnSustainer = 'OS',
  NaturalPerson = 'NP',
  NaturalPersonWithPassport = 'NPWP',
  LegalPerson = 'LP',
}

export const childrensOptions = [
  { value: 1, label: 'Sí' },
  { value: 0, label: 'No' },
];

export const drivingLicenseOptions = [
  { value: 1, label: 'Sí' },
  { value: 0, label: 'No' },
];

// Reformada
export const populationOptions = [
  {
    value: 'N/A',
    label: 'Ninguna',
  },
  {
    value: 'IP',
    label: 'Población indígena',
  },
  {
    value: 'ADP',
    label: 'Población afrodescendiente',
  },
  {
    value: 'VAC',
    label: 'Población víctima de conflicto armado',
  },
  {
    value: 'GIT',
    label: 'Gitanos',
  },
  {
    value: 'VET',
    label: 'Veteranos',
  },
];

export const socioEconomicStratumOptions = [
  {
    value: '1',
    label: '1',
  },
  {
    value: '2',
    label: '2',
  },
  {
    value: '3',
    label: '3',
  },
  {
    value: '4',
    label: '4',
  },
  {
    value: '5',
    label: '5',
  },
  {
    value: '6',
    label: '6 ',
  },
];
export const parenthoodOptions = [
  {
    label: 'Madre',
    value: 'M',
  },
  {
    label: 'Padre',
    value: 'F',
  },
  {
    label: 'Otro',
    value: 'O',
  },
];

export enum IcfesFormatType {
  BEF99 = 'BEF99',
  BET0005 = 'BET0005',
  BET0614 = 'BET0614',
  BET1416 = 'BET1416',
  BET1620 = 'BET1620',
  AFT21 = 'AFT21',
}

export const icfesFormatOptions = [
  {
    label: 'Anterior a 1999',
    value: 'BEF99',
  },
  {
    label: 'Entre 2000 y 2005',
    value: 'BET0005',
  },
  {
    label: 'Entre 2006 y 2014',
    value: 'BET0614',
  },
  {
    label: 'Entre 2014 a 2016',
    value: 'BET1416',
  },
  {
    label: 'Entre 2016 y 2020',
    value: 'BET1620',
  },
  {
    label: 'A partir de 2021',
    value: 'AFT21',
  },
];

export const icfesFormatFields: Record<IcfesFormatType, string[]> = {
  BEF99: [
    'gradeNaturalSciences',
    'gradeSocial',
    'gradeLenguaje',
    'gradeMathematics',
    'gradeElective',
  ],
  BET0005: [
    'gradeMathematics',
    'gradeLenguaje',
    'gradeBiology',
    'gradePhilosophy',
    'gradePhysics',
    'gradeHistory',
    'gradeChemistry',
    'gradeGeography',
    'gradeInterdisciplinary',
    'gradeEnglish',
  ],
  BET0614: [
    'gradeMathematics',
    'gradeLenguaje',
    'gradeBiology',
    'gradePhilosophy',
    'gradePhysics',
    'gradeChemistry',
    'gradeInterdisciplinary',
    'gradeEnglish',
    'gradeSocial',
  ],
  BET1416: [
    'gradeNaturalSciences',
    'gradeMathematics',
    'gradeEnglish',
    'gradeCriticalReading',
    'gradeCitizenship',
    'gradeQuantitativeReasoning',
    'gradeCivicCompetences',
  ],
  BET1620: [
    'gradeNaturalSciences',
    'gradeMathematics',
    'gradeEnglish',
    'gradeCriticalReading',
    'gradeCitizenship',
  ],
  AFT21: [
    'gradeNaturalSciences',
    'gradeMathematics',
    'gradeEnglish',
    'gradeCriticalReading',
    'gradeCitizenship',
    'gradeGlobal',
    'gradePosition',
  ],
};
